import { render, staticRenderFns } from "./change-avatar.vue?vue&type=template&id=20e7bca5&"
import script from "./change-avatar.vue?vue&type=script&lang=js&"
export * from "./change-avatar.vue?vue&type=script&lang=js&"
import style0 from "./change-avatar.vue?vue&type=style&index=0&id=20e7bca5&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports